/**
 * `/projects/:id` — bookmarks keep working; the Before-PDP shell is gone (Ticket 68).
 * Lifecycle actions live on the project list row; opening a project goes to Live.
 */

import { Navigate, useParams } from "react-router-dom";

export function ProjectDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <Navigate to={`/projects/${id}/live`} replace />;
}
